export default{
  shipping_method: 'método de envio',
  shipping_time: 'Prazo de entrega',
  costs: 'Custos',
  shipping_to: 'Enviando para'
}


// WEBPACK FOOTER //
// ./src/i18n/pt.js